const messages = {
    buttons: {
        productBrochures: "Felfedezés",
    },
    index: {
        title: "TERMÉKINFORMÁCIÓK",
        description: "Itt letöltheti a Bridgestone és Firestone gumiabroncsaink legújabb prospektusait és szórólapjait.",
        categories: {
            productBrochures: {
                title: "Termékprospektusok",
                description: "Bridgestone és Firestone gumiabroncs sorozatok prospektusai",
            },
            bDrive: {
              title: "Termékképek",
              description: "Az aktuális képek letölthetők a B-DRIVE portálunkról.",
            },
        
          kickback: {
            description: "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
          },}
    }
};

export default {
    messages,
};

